import { Button } from '@mantine/core';
import { useQueryClient } from '@tanstack/react-query';
import { Icon, useAsyncActionWithToast, variants } from '@uag/react-core';
import { useGetBranchesByCountryCode } from '@uag/welcome-shared/src/api/queries/branches/branches';
import {
    getGetRequestDetailQueryKey,
    getGetRequestsQueryKey,
    useChangeResponsibleTeam,
} from '@uag/welcome-shared/src/api/queries/requests/requests';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { openForwardRequestModal } from '../modals/ForwardRequestModal';
import { useRequestContext } from '../RequestProvider';
import { RequestActionButtonProps } from './types';

export const ForwardRequestAction = (_: RequestActionButtonProps) => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const { request } = useRequestContext();
    const { mutateAsync: forwardRequest } = useChangeResponsibleTeam();

    const countryConfiguration = request.companyData.mainAddress?.countryConfiguration;

    const [teamName, setTeamName] = useState();

    const countryCode = countryConfiguration?.countryCode;
    const { data: branches } = useGetBranchesByCountryCode(countryCode ?? '');

    const { run } = useAsyncActionWithToast({
        action: forwardRequest,
        successMessageKey: 'forwardRequestSuccessMessage',
        successMessageParameters: () => ({ team: teamName }),
        errorMessageKey: 'forwardRequestError',
    });

    if (!countryConfiguration || !countryConfiguration?.teamsByBranch || !branches) {
        return;
    }
    const handleForward = async () => {
        const result = await openForwardRequestModal({
            countryConfiguration,
        });

        if (!result) {
            return;
        }

        const { identifier: branchIdentifier, name: teamName } = result;
        setTeamName(teamName);
        await run({ id: request.id, params: { branchIdentifier } });

        queryClient.invalidateQueries({ queryKey: getGetRequestDetailQueryKey(request.id) });
        queryClient.invalidateQueries({ queryKey: getGetRequestsQueryKey() });
    };

    return (
        <Button variant={variants.button.secondary} onClick={handleForward}>
            {t('forward')}
            <Icon className="ml-base" icon="shortcut" />
        </Button>
    );
};
